var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-area',{attrs:{"title":"Materiais"}},[(_vm.isModoPadrao || _vm.isSaved)?[(!_vm.isSaved)?_c('PadraoForm',{ref:"PadraoForm",attrs:{"data":_vm.data}}):_vm._e(),_c('PadraoList',{ref:"PadraoList",attrs:{"data":_vm.data,"is-saved":_vm.isSaved}})]:_c('SequencialList',{ref:"SequencialList",attrs:{"data":_vm.data}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }